import { Box, Typography } from "@mui/material";
import { useIsMobileView } from "../../utils/responsive";
import { Configuration } from "../configuration/modules/GeneralSettings";
import { useAppSelector } from "../../store/hooks/useAppSelector";
import { RootState } from "../../store/types/rootState";
import ReportsMenu from "../reports/ReportsMenu";
import { useEffect } from "react";
import { useGetRaffleReportsQuery } from "../../store/api";



export const ReportsPage = () => {

  const selectedRaffle = useAppSelector(
    ({ selectedRaffle }: RootState) => selectedRaffle,
  );

  const { data: reportsData, error: errorGetRaffleStatus } = useGetRaffleReportsQuery(selectedRaffle.id, {
      skip: selectedRaffle.id === 'default',
      refetchOnReconnect: true,
      refetchOnFocus: true,
      refetchOnMountOrArgChange: true,
  });

  useEffect(() => {
    console.log(selectedRaffle.name)
  }, [selectedRaffle])
  

  const isMobileView = useIsMobileView();

  return (
    <Box paddingX={isMobileView ? 2 : 10} marginTop={2}>
      <Typography variant="h6" fontFamily={"Georgia"} paddingBottom={2}>
        Reportes <strong>{selectedRaffle.name}</strong>
      </Typography>
      <Box mx={10}>
        {selectedRaffle.id != 'default' && reportsData ? <ReportsMenu raffle={selectedRaffle} reportsData={reportsData} /> : null}
      </Box>
    </Box>
  );
};
